import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

import { StoreDeliveryList as RedesignStoreDeliveryList } from '../../../pages';
import * as Api from '../../Api';
import * as Data from '../../Data';
import { flagService } from '../../services';
import * as Store from '../../Store';
import { default as LegacyDeliveryList } from './index.weborder';

const pageComponent = flagService.componentToggle(
  'uiRedesign',
  RedesignStoreDeliveryList,
  LegacyDeliveryList,
);

export type RouteProps = {
  params: {
    location: number; // delivery location ID.
  };
};

export type StateProps = {
  AppConfig: Data.Async<Api.AppConfig>;
  AppDesignScheme: Api.AppDesignScheme;
  deliveryOption?: Data.Async<Store.DeliveryOption>; // keyed by delivery location id
  deliveryRestaurants: Store.DeliveryMap;
  isDark: boolean;
  translate: any;
};

const mapStateToProps = (
  state: Store.State,
  ownProps: RouteProps,
): StateProps => ({
  AppConfig: state.flipdish.AppConfig,
  AppDesignScheme: state.appDesignScheme,
  deliveryOption: state.deliveryOptions[ownProps.params.location],
  deliveryRestaurants: state.deliveryRestaurants,
  isDark: state.flipdish.isDark,
  translate: getTranslate(state.locale),
});

export default connect(mapStateToProps)(pageComponent);
